<template>
  <OverlayCard :close-button="false" ref="Overlay">
    <template #content>
      <ColorPicker :colors="colors" :no-color-allowed="true" v-model="value" />
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { colorArray } from '@common/codecolors/codecolors';
import { ICellRendererParams } from 'ag-grid-community';

export default defineComponent({
  name: 'EditColorCellRenderer',

  props: {
    params: {
      type: Object as PropType<ICellRendererParams<any, string>>,
      required: true,
    },
  },

  mounted() {
    this.value = this.params.value;
  },
  data(): { value: string | null } {
    return {
      value: null,
    };
  },
  methods: {
    /**
     * @public
     */
    getValue() {
      return this.value;
    },
  },
  computed: {
    colors() {
      return colorArray;
    },
  },
});
</script>
